import { createSelector } from 'reselect'
import createSortedCardStatusesSelector from 'routes/Board/selectors/createSortedCardStatusesSelector'
import createStatusSelector from '../../selectors/createStatusSelector'

const getCardId = (state, props) => props.cardContext.id

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

const getCardStatusIds = (state, props) => {
  return state['view-board'].cardStatuses[state['view-board'].cards[props.cardContext.id].boardId].ids
}

export default () => {
  const sortedCardStatusesSelector = createSortedCardStatusesSelector(getCardStatusIds)
  const statusSelector = createStatusSelector(getCardId)

  return createSelector(
    [
      getIsArchived,
      sortedCardStatusesSelector,
      statusSelector,
    ],
    (
      isArchived,
      cardStatuses,
      status,
    ) => ({
      isArchived,
      cardStatuses,
      status,
    })
  )
}
